import Expired from './Expired-view';

export default Expired;
